<template>
  <div class="division" :style="{ border: '6px solid ' + item.color }">
    <img :src="require(`../assets/${item.img_name}.png`)" />
    <div class="title-div" :style="{ color: item.color }">
      {{ item.title }}
    </div>
  </div>
</template>
<style>
.division-main {
  letter-spacing: 0px !important;
  color: #ffffff !important;
}

.division-main .v-toolbar__content .v-btn {
  color: #ffffff;
}

.division-main .v-btn.v-size--default {
  font-size: unset;
}

.division-main,
.iframe-div {
  height: calc(100% - 75px);
}

.division-main iframe {
  height: 100%;
  width: 100%;
}

.division-main .v-btn::before,
.division-main .v-btn:before,
.division-main .v-btn .theme--light.v-btn:focus::before {
  background-color: none !important;
  opacity: 0 !important;
}

.division-main .v-btn .v-ripple__container {
  display: none !important;
}
@media (max-width: 600px) {
  .division-main .v-toolbar__content {
    height: unset !important;
  }

  .division-main {
    padding-top: 140px;
    font: normal normal bold 15px/18px Roboto !important;
  }

  .division-main .v-sheet.v-sheet--tile.theme--light.v-toolbar {
    border-radius: 40px;
  }

  .division-main .v-toolbar__items .v-btn {
    height: 25px !important;
  }

  .division-main .v-toolbar__items {
    display: block;
  }

  .division-main .btn-div.not-selected {
    border-bottom: 2px solid transparent;
  }

  .division-main .btn-div.selected {
    border-bottom: 2px solid #ffffff;
  }

  .division-main,
  .iframe-div {
    height: calc(100% - 41px);
  }
}

@media (min-width: 600px) {
  .division-main .v-toolbar__content {
    height: 58px;
  }

  .division-main {
    padding-top: 140px;
    font: normal normal bold 20px/24px Roboto !important;
  }

  .division-main .v-sheet.v-sheet--tile.theme--light.v-toolbar {
    border-radius: 36px;
    margin: 44px 28px 0 28px;
  }

  .division-main .iframe-div {
    margin: 41px 66px 0 66px;
  }

  .division-main .btn-div.not-selected {
    padding-bottom: 12px;
    border-bottom: 4px solid transparent;
  }

  .division-main .btn-div.selected {
    padding-bottom: 12px;
    border-bottom: 4px solid #ffffff;
  }
}
</style>
<script>
import { Trans } from "@/plugins/Translation";
import router from "@/router/index.js";

export default {
  props: {
    division: "",
    item: {
      title: String,
      img_name: String,
      color: String,
    },
  },
  data() {
    return {
      isMobile: false,
    };
  },

  created() {
    window.addEventListener("resize", this.myEventHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  methods: {
    getImageHeight(division) {
      if (!this.isMobile) {
        return "height: " + division.img_height;
      }
    },
    myEventHandler(e) {
      this.setIsMobile();
    },
    setIsMobile() {
      this.isMobile = window.innerWidth < this.$genericClass.mobileMaxWidth();
    },
  },
};
</script>